import * as React from 'react';
import { Form } from 'react-bootstrap';
import { ErrorMessage } from 'formik';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
  createWaDaddyCredential,
  updateWaDaddyCredential,
  getWaDaddyCredential,
} from '../../../redux/actions/WaDaddy.action';

const waDaddyPhoneInputStyles = `
  .wadaddy-phone-input .flag-dropdown {
    border-color: #ced4da;
  }
    .wadaddy-phone-input .selected-flag {
    width: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wadaddy-phone-input .selected-flag .flag,
  .wadaddy-phone-input .country-list .country .flag {
    display: none !important;
  }
  /* Replace the library's default triangle arrow with a clearer
     chevron icon so it reads as a clickable "select country" control
     now that the flag image is gone. */
  .wadaddy-phone-input .selected-flag .arrow {
    display: none;
  }
  .wadaddy-phone-input .selected-flag::after {
    content: '';
    position: static;
    width: 7px;
    height: 7px;
    border-right: 2px solid #6c757d;
    border-bottom: 2px solid #6c757d;
    transform: rotate(45deg);
    margin-top: -3px;
    pointer-events: none;
  }
  .wadaddy-phone-input input.form-control {
    padding-left: 42px;
  }
  .wadaddy-phone-input .country-list {
    width: 300px;
    z-index: 2000;
  }
  .wadaddy-phone-input .country-list .country {
    display: flex;
    align-items: center;
    padding: 8px 12px;
  }
  .wadaddy-phone-input .country-list .country-name {
    margin-right: 6px;
  }
  .wadaddy-phone-input .country-list .country .dial-code {
    color: #6c757d;
  }
`;

const WA_DADDY_ID_CACHE_PREFIX = 'waDaddyCredentialId:';
const WA_DADDY_VALUES_CACHE_PREFIX = 'waDaddyCache:';

const cacheCredentialId = (adminId, credentialId) => {
  if (!adminId || !credentialId) return;
  try {
    localStorage.setItem(`${WA_DADDY_ID_CACHE_PREFIX}${adminId}`, credentialId);
  } catch (e) {}
};

const getCachedCredentialId = (adminId) => {
  if (!adminId) return null;
  try {
    return localStorage.getItem(`${WA_DADDY_ID_CACHE_PREFIX}${adminId}`);
  } catch (e) {
    return null;
  }
};

export const seedWaDaddyCredentialId = (adminId, credentialId) => {
  cacheCredentialId(adminId, credentialId);
};
if (typeof window !== 'undefined') {
  window.seedWaDaddyCredentialId = seedWaDaddyCredentialId;
}

const cacheWaDaddyValuesLocally = (adminId, values) => {
  if (!adminId) return;
  try {
    localStorage.setItem(
      `${WA_DADDY_VALUES_CACHE_PREFIX}${adminId}`,
      JSON.stringify({
        facebookAppId: values.facebookAppId || '',
        registerdPhoneNumber: values.registerdPhoneNumber || '',
        phoneNumberId: values.phoneNumberId || '',
        wbaId: values.wbaId || '',
        accessToken: values.accessToken || '',
        apikey: values.apikey || '',
      }),
    );
  } catch (e) {}
};

export const getCachedWaDaddyValues = (adminId) => {
  if (!adminId) return null;
  try {
    const raw = localStorage.getItem(
      `${WA_DADDY_VALUES_CACHE_PREFIX}${adminId}`,
    );
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const fetchWaDaddyCredential = async (dispatch, adminId) => {
  const cachedId = getCachedCredentialId(adminId);
  let credential = null;
  if (cachedId) {
    const res = await dispatch(getWaDaddyCredential(cachedId));
    credential = res?.data?.data;
  }
  if (!credential || credential.status === false || !credential._id) {
    const res = await dispatch(getWaDaddyCredential(adminId));
    credential = res?.data?.data;
  }
  if (!credential || credential.status === false || !credential._id) {
    return null;
  }
  cacheCredentialId(adminId, credential._id);
  return {
    facebookAppId: credential.facebookAppId || '',
    registerdPhoneNumber: credential.registerdPhoneNumber || '',
    phoneNumberId: credential.phoneNumberId || '',
    wbaId: credential.wbaId || '',
    accessToken: credential.accessToken || '',
    apikey: credential.apikey || '',
  };
};

export const saveWaDaddyCredential = async (dispatch, adminId, values) => {
  if (!values?.isWadaddy || !adminId) return;
  const waData = {
    facebookAppId: values.facebookAppId,
    registerdPhoneNumber: values.registerdPhoneNumber,
    phoneNumberId: values.phoneNumberId,
    wbaId: values.wbaId,
    accessToken: values.accessToken,
    apikey: values.apikey,
  };
  const credentialId = getCachedCredentialId(adminId);
  let res;
  if (credentialId) {
    res = await dispatch(updateWaDaddyCredential(credentialId, waData));
  } else {
    res = await dispatch(createWaDaddyCredential(adminId, waData));

    if (res?.data?.data?.status === false) {
      const getRes = await dispatch(getWaDaddyCredential());
      const existing = getRes?.data?.data;
      if (existing?._id) {
        cacheCredentialId(adminId, existing._id);
        res = await dispatch(updateWaDaddyCredential(existing._id, waData));
      }
    }
  }
  if (res?.data?.data?._id) {
    cacheCredentialId(adminId, res.data.data._id);
    cacheWaDaddyValuesLocally(adminId, values);
  }
  return res;
};

const WaDaddyForm = ({ values, setFieldValue }) => {
  return (
    <div className="col-12 mb-3">
      <style>{waDaddyPhoneInputStyles}</style>
      <div className="border rounded p-3" style={{ background: '#f8f9fb' }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">WhatsApp API Integration</h5>
          <span className="fw-bold text-muted">
            Balance: <span className="text-danger">-</span>
          </span>
        </div>

        <Form.Group className="mb-3">
          <Form.Label>
            Facebook APP ID: <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={values.facebookAppId}
            onChange={(e) => setFieldValue('facebookAppId', e.target.value)}
            placeholder="Enter Facebook App ID"
            className="shadow-none focus:!border-theme-dark"
          />
          <ErrorMessage
            name="facebookAppId"
            component="div"
            className="text-danger"
          />
        </Form.Group>

        <div className="fw-bold mb-2">
          Enter your Official WhatsApp API Credentials
        </div>

        <Form.Group className="mb-3">
          <Form.Label>
            Registered Number (with country code):{' '}
            <span className="text-danger">*</span>
          </Form.Label>
          <PhoneInput
            country={'in'}
            value={values.registerdPhoneNumber}
            onChange={(value, country) => {
              const digitsOnly = value.replace(/\D/g, '');
              const dialCode = country?.dialCode || '';
              const nationalDigits = digitsOnly.slice(dialCode.length);
              const maxDigits = country?.format
                ? (country.format.match(/\./g) || []).length
                : null;
              const limitedDigits = maxDigits
                ? nationalDigits.slice(0, maxDigits)
                : nationalDigits;
              setFieldValue(
                'registerdPhoneNumber',
                `+${dialCode}${limitedDigits}`,
              );
            }}
            containerClass="wadaddy-phone-input"
            inputClass="form-control shadow-none focus:!border-theme-dark"
            inputStyle={{ width: '100%', height: '38px' }}
            buttonStyle={{ borderColor: '#ced4da' }}
            dropdownStyle={{ zIndex: 2000 }}
            enableSearch
            placeholder="Enter WhatsApp registered number"
          />
          <ErrorMessage
            name="registerdPhoneNumber"
            component="div"
            className="text-danger"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            Phone Number Id: <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={values.phoneNumberId}
            onChange={(e) => setFieldValue('phoneNumberId', e.target.value)}
            placeholder="Enter Phone Number Id"
            className="shadow-none focus:!border-theme-dark"
          />
          <ErrorMessage
            name="phoneNumberId"
            component="div"
            className="text-danger"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            WhatsApp Business Account Id: <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={values.wbaId}
            onChange={(e) => setFieldValue('wbaId', e.target.value)}
            placeholder="Enter WhatsApp Business Account Id"
            className="shadow-none focus:!border-theme-dark"
          />
          <ErrorMessage name="wbaId" component="div" className="text-danger" />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            Permanent Access Token: <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={values.accessToken}
            onChange={(e) => setFieldValue('accessToken', e.target.value)}
            placeholder="Enter Permanent Access Token"
            className="shadow-none focus:!border-theme-dark"
          />
          <ErrorMessage
            name="accessToken"
            component="div"
            className="text-danger"
          />
        </Form.Group>

        <Form.Group className="mb-0">
          <Form.Label>
            Api Key: <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={values.apikey}
            onChange={(e) => setFieldValue('apikey', e.target.value)}
            placeholder="Enter Api Key"
            className="shadow-none focus:!border-theme-dark"
          />
          <ErrorMessage name="apikey" component="div" className="text-danger" />
        </Form.Group>
      </div>
    </div>
  );
};

export default WaDaddyForm;
